import { render } from "./EventTrendHistogram.vue?vue&type=template&id=67e5500c&scoped=true"
import script from "./EventTrendHistogram.vue?vue&type=script&lang=js"
export * from "./EventTrendHistogram.vue?vue&type=script&lang=js"

import "./EventTrendHistogram.vue?vue&type=style&index=0&id=67e5500c&scoped=true&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67e5500c"]])

export default __exports__